import React, { useState } from 'react';
import { Container } from '../style';
import "./eduProgramm.css"
import { useTranslation } from 'react-i18next';


const EduCenter = () => {
    const { t } = useTranslation();
  const [activeFilter, setActiveFilter] = useState('all');
    return (
        <Container>
            <br/>
            <br/>
            <br/>
            <div className="training-plan">
      <div className="training-plan__filters">
        {Object.entries(t('filters', { returnObjects: true })).map(([key, value]) => (
          <button
            key={key}
            className={`training-plan__filter ${
              activeFilter === key ? 'training-plan__filter--active' : ''
            }`}
            onClick={() => setActiveFilter(key)}
          >
            {value}
          </button>
        ))}
      </div>

      <div className="training-plan__search">
        <input
          type="text"
          className="training-plan__search-input"
          placeholder={t('search.placeholder')}
        />
      </div>

      <ul className="training-plan__list">
        {t('events', { returnObjects: true }).map((event, index) => (
        
          <li key={index} className="training-item">
            <h2 className="training-item__title">{event.title}</h2>
            
            <div className="training-item__row">
              <div className="training-item__label">
                {t('trainingItem.labels.month')}:
              </div>
              <div className="training-item__content">{event.month}</div>
            </div>

            {/* <div className="training-item__row">
              <div className="training-item__label">
                {t('trainingItem.labels.format')}:
              </div>
              <div className="training-item__content">
                <span
                  className={`training-item__mode training-item__mode--${event.mode}`}
                >
                  {t(`trainingItem.modes.${event.mode}`)}
                </span>
              </div>
            </div> */}

            <div className="training-item__row">
              <div className="training-item__label">
                {t('trainingItem.labels.language')}:
              </div>
              <div className="training-item__content">
                <span className="training-item__language">
                  {t(`trainingItem.languages.${event.language}`)}
                </span>
              </div>
            </div>

            <div className="training-item__row">
              <div className="training-item__label">
                {t('trainingItem.labels.responsible')}:
              </div>
              <div className="training-item__content">{event.responsible}</div>
            </div>
          </li>
       
        ))}
      </ul>
    </div>
            <br/>
            <br/>
            <br/>
        </Container>
    );
}

export default EduCenter;
